export const getMasterAppInfo = () => {
  return window.masterApp;
};
